import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-arrow-up-icon',
  templateUrl: 'arrow-up-icon.component.html'
})
export class ArrowUpIconComponent {
  constructor() {}
}
